<template>
  <!-- 导出只包含国家、省、校级资源库,不含精品课省级报告 -->
  <div class="analysisReport">
    <el-button type="primary" class="export" @click="exportPdf">导出pdf</el-button>
    <div class="analysisReport_box" id="pdfPrint" ref="pdfContent">
      <!-- PDF  首页 -->
      <div
        class="HomePage page-box">
        <!-- 图片 -->
        <div id="image"></div>
        <!-- 正文 -->
        <div id="PdfTitle">
          <span v-show="false">这是completeNum的值：{{completeNum  }}</span>
          <input id="completeNum" v-model="completeNum" v-show="false" />
          <p id="FristTitle">{{ province }}</p>
          <p id="FristTitle">职业教育专业教学资源库<span v-if="type == 1">建设及应用监测月度分析报告</span><span v-if="type == 2">建设及应用监测季度分析报告</span><span v-if="type == 3">建设及应用监测年度分析报告</span>
          </p>
          <p id="SecondTitle" v-if="type == 1">
            <span id="ThrendTitle">（{{ nowYear }}年{{ nowMonth }}月）</span>
          </p>
          <p id="SecondTitle" v-if="type == 2">
            <span id="ThrendTitle">（{{ nowYear }}年{{ Titledate.Quarter }}）</span>
          </p>
          <p id="SecondTitle" v-if="type == 3">
            <span id="ThrendTitle">（{{ nowYear }}年）</span>
          </p>
          <p id="FourTitle">运行分析起止时间：{{ startDay }} 至 {{ endDay }}</p>
        </div>
        <!-- 底部 -->
        <div id="foot">
          <div class="footBox" style="margin-left: 21%">
            <p>职业教育专业教学资源库运行监测平台项目组</p>
            <p>广东轻工职业技术学院产教融合大数据研究所</p>
            <p>
              <span v-if="nowMonth != '12'">{{ nowYear }}年</span>
              <span v-else>{{ +nowYear + 1 }}年</span>
              <span v-if="nowMonth != '12'">{{ +nowMonth + 1 }}</span
              ><span v-else>1</span> 月 10 日
            </p>
          </div>
        </div>
      </div>
      <!-- 目录 -->
      <div class="catalogue page-box">
        <div class="title">
          <p style="font-size: 60px; font-weight: 700">
            目&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录
          </p>
        </div>
        <h5 class="Second_text">
          1 {{ over }}内专业教学资源库整体运行情况分析<span class="dot"></span>1
        </h5>

        <div class="Thred_text">
          <h5>1.1 用户建设及应用运行情况<span class="dot"></span>1</h5>
          <h5>1.2 课程建设及应用情况<span class="dot"></span>2</h5>
          <h5>1.3 资源建设及应用情况<span class="dot"></span>3</h5>
          <h5>1.4 资源库总体应用情况<span class="dot"></span>3</h5>
          <h5>
            1.5 &nbsp;<span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
            <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
            <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
            <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}资源库整体运行情况分析<span
            class="dot"
          ></span
          >4
          </h5>
        </div>
        <h5 class="Second_text">2 {{ over }}内原国家级专业教学资源库运行情况分析<span class="dot"></span>7</h5>
        <div class="Thred_text">
          <h5>2.1 用户建设及应用情况<span class="dot"></span>7</h5>
          <h5>2.2 课程建设及应用情况<span class="dot"></span>8</h5>
          <h5>2.3 资源建设及应用情况<span class="dot"></span>8</h5>
          <h5>2.4 资源库总体应用情况<span class="dot"></span>8</h5>
          <h5>
            2.5 &nbsp; <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
            <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
            <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
            <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}原国家级资源库运行情况分析<span
              class="dot"
            ></span
            >9
          </h5>
        </div>
        <h5 class="Second_text" v-if="provinceUnNormalPushData.length!=0">3 {{ over }}内已纳入监测但数据尚未正常推送的资源库列表<span class="dot"></span>12</h5>
      </div>

      <!-- 第一页 -->
      <div class="chart_box page-box">
        <div class="header_titles">
          <h1>{{ province }}职业教育专业教学资源库</h1>
          <h1 style="margin-top: 20px" v-if="type == 1">
            建设及应用监测月度分析报告（{{ nowYear }}年{{ nowMonth }}月）
          </h1>
          <h1 style="margin-top: 20px" v-if="type == 2">
            建设及应用监测季度分析报告（{{ nowYear }}年{{ Titledate.Quarter }}）
          </h1>
          <h1 style="margin-top: 20px" v-if="type == 3">
            建设及应用监测年度分析报告（{{ nowYear }}年）
          </h1>
          <div class="number_time">
            <div>
              <span></span>
              <span>统计时间：{{ startDay }} 至 {{ endDay }}</span>
            </div>
            <p></p>
            <p></p>
          </div>
        </div>
        <h4>1 {{ over }}内专业教学资源库整体运行情况分析</h4>
        <p>
          截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，{{ province }}已纳入监测资源库共计{{zykRunAnalysis.zykCount}}个，
          其中正常推送数据的资源库有{{zykRunAnalysis.normalZykCount}}个，尚有{{zykRunAnalysis.normalUnZykCount}}个资源库数据推送异常。在已纳入监测且数据正常推送的{{zykRunAnalysis.normalZykCount}}个资源库中，
          原国家级资源库有{{zykRunAnalysis.countryNormalPushZykNum}}个，{{ over }}级资源库{{
          zykRunAnalysis.cityNormalPushZykNum
          }}个，校级资源库{{ zykRunAnalysis.schoolNormalPushZykNum }}个，覆盖{{
          zykRunAnalysis.professionBigClassNum
          }}个专业大类和{{ zykRunAnalysis.professionCount }}个二级专业类。 目前，{{ province }}已有{{
          zykRunAnalysis.buildSchoolNum
          }}所职业院校和{{ zykRunAnalysis.companyCount }}家行业企业参与建设。这些资源库中课程总量已达{{
          getUtils_Fun(zykRunAnalysis.courseTotal)
          }}门，资源总量达{{ getUtils_Fun(zykRunAnalysis.resourceValueTotal) }}余条，资源容量
          {{
          formatValue(zykRunAnalysis.resourceStorage / 1024 / 1024)
          }}TB ，共有注册用户{{
          getUtils_Fun(zykRunAnalysis.zykUserTotalNum)
          }}余人，总访问次数{{
          getUtils_Fun(zykRunAnalysis.zykVisitTotal)
          }}次，为推动职业教育专业教学改革和职业院校信息化建设贡献了力量。具体建设应用情况分析如下：
        </p>
        <h5>1.1 用户建设及应用情况</h5>
        <p>
          当前，{{ province }}资源库共有注册用户{{
          getUtils_Fun(userBuildApply.zykUserTotalNum)
          }}余人，参与院校{{ zykRunAnalysis.buildSchoolNum }}所。按用户身份类型统计，教师{{
          getUtils_Fun(userBuildApply.teachNum)
          }}余人，其中实名教师{{
          getUtils_Fun(userBuildApply.realNameTeacher)
          }}余人；学生{{ getUtils_Fun(userBuildApply.stuNum) }}余人，其中实名学生{{
          getUtils_Fun(userBuildApply.realNameStudent)
          }}余人；企业用户{{
          getUtils_Fun(userBuildApply.companyNum)
          }}余人，社会学习者{{ getUtils_Fun(userBuildApply.socialNum) }}余人，活跃学生数达{{
          getUtils_Fun(userBuildApply.activeStudent)
          }}人。其中资源库中注册用户最多的是{{ userBuildApply.registerTopSchoolName }}，为{{
          getUtils_Fun(userBuildApply.registerTopSchoolValue)
          }}人。
        </p>
        <p>
          目前，资源库中在线学习人数最多的则是{{ userBuildApply.studyTopSchoolName }}，共{{
          getUtils_Fun(userBuildApply.studyTopSchoolValue)
          }}人；互动交流次数累计{{ getUtils_Fun(userBuildApply.communicateNum) }}次，
          互动交流频次最多的是{{ userBuildApply.communicateTopSchoolName }}。
          <!--          其次是{{-->
          <!--            userBuildApply.communicateSecondSchoolName-->
          <!--          }}。-->
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="userBuildApply.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">图1 用户整体情况</div>
        <p style="margin-top: 150px">
          近一年学生用户访问总量达{{
          getUtils_Fun(userBuildApply.studentVisitTotal)
          }}次，教师用户访问量达{{
          getUtils_Fun(userBuildApply.teacherVisitTotal)
          }}次，具体访问趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="userBuildApply.studentTeacherDataList"
            :transverseData="userBuildApply.studentTeacherTransverse"
            :colorList="colorList"
            :legendList="['学生', '教师']"
            :innerText="'单位：次'"
          ></discountChart>
        </div>
        <div class="chart_name">图2 最近一年教师和学生访问情况</div>
      </div>

      <!-- 第二页 -->
      <div class="chart_box page-box">
        <div class="standards_content echartsHeight" style="margin-top: 150px">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="userBuildApply.socialCompanyDataList"
            :transverseData="userBuildApply.socialCompanyTransverse"
            :colorList="colorList"
            :legendList="['社会学习者', '企业用户']"
            :innerText="'单位：次'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图3 最近一年社会学习者和企业用户访问情况</div>
        <h5 class="m-top150">1.2 课程建设及应用情况</h5>
        <p>
          当前，{{ province }}资源库项目课程总量达到{{
          getUtils_Fun(courseBuildApply.standard + courseBuildApply.personality)
          }}门，其中标准化课程{{ courseBuildApply.standard }}门，个性化课程{{
          getUtils_Fun(courseBuildApply.personality)
          }}门。用户访问最多的课程是《{{ courseBuildApply.name }}》，属于“{{
          courseBuildApply.zykName
          }}资源库”。 课程按类型分布详情如下：
        </p>
        <div class="standards_content echartsHeight" style="margin-top: 150px">
          <tcolumnarChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="[courseBuildApply.standard, courseBuildApply.personality]"
            :transverseData="['标准化课程', '个性化课程']"
            :colorList="colorList"
            :colorName="2"
            :innerText="'单位：门'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图4 课程整体情况</div>
        <div class="standards_content echartsHeight m-top150">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="courseVo.value"
            :transverseData="courseVo.name"
            :colorList="colorList"
            :innerText="'单位：次'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图5 最近一年课程访问情况</div>
      </div>

      <!-- 第三页 -->
      <div class="chart_box page-box">
        <h5 style="margin-top: 150px">1.3 资源建设及应用情况</h5>
        <p v-if="resourceBuildApply.resourceTypeMap.name.length > 0">
          {{ province }}资源库项目资源数量达{{
          getUtils_Fun(resourceBuildApply.resourceValueTotal)
          }}条，存储总容量{{
          formatValue(resourceBuildApply.resourceStorage / 1024 / 1024)
          }}TB，原创资源{{formatValue((resourceBuildApply.orignalResource/resourceBuildApply.resourceValueTotal)*100)}}%，资源访问总量已达{{ getUtils_Fun(resourceBuildApply.resourceVisitTotal) }}余次。 题库数量{{getUtils_Fun(resourceBuildApply.questionNum)}}条，题库使用率{{resourceBuildApply.questionActivePercent}}。
        </p>
        <p>
          所有资源中图形(图像)类和文本类资源占比{{resourceBuildApply.texImagePercent}}；“{{ resourceBuildApply.resourceTypeMap.name[0] }}”资源数量最多，
          达到{{
          getUtils_Fun(resourceBuildApply.resourceTypeMap.value[0])
          }}条；微课有{{getUtils_Fun(resourceBuildApply.smallCourse)}}门。除此之外，各资源库项目还开发了大量的实践教学资源，
          拥有{{getUtils_Fun(resourceBuildApply.virtualNum)}}条虚拟仿真资源。
        </p>
        <p>资源按类型分布详情如下：</p>
        <div class="standards_content echartsHeight" style="height: 31.25rem">
          <tcolumnarChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="resourceBuildApply.resourceTypeMap.value"
            :transverseData="resourceBuildApply.resourceTypeMap.name"
            :colorList="colorList"
            :colorName="2"
            :innerText="'单位：条'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图6 资源整体情况</div>
        <div class="standards_content echartsHeight m-top150" style="margin-top: 150px">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="resourceBuildApply.resourceVo.value"
            :transverseData="resourceBuildApply.resourceVo.name"
            :colorList="colorList"
            :innerText="'单位：次'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图7 最近一年资源访问情况</div>
        <h5>1.4 资源库总体应用情况</h5>
        <p>1. 覆盖专业大类分析</p>
        <p v-if="zykWholeCase.professionBigClassList.length > 0">
          截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，{{ province }}资源库覆盖{{
          zykWholeCase.professionBigClassNum
          }}个专业大类。从专业大类分布看，所属{{
          zykWholeCase.professionBigClassList[0].name
          }}的资源库最多，占比达{{
          ((zykWholeCase.professionBigClassList[0].value / zykWholeCase.total) * 100).toFixed(2)
          }}%，具体分布如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="zykWholeCase.professionBigClassList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'25%'"
            :legendBackgroundColor="true"
            :legendLeft="'45%'"
            :showValue="true"
            :unit="'个'"
            :circleSize="80"
            :seriesRight="'50%'"
          ></circularChart>
        </div>
        <div class="chart_name">图8 资源库专业大类分布情况</div>
      </div>

      <!-- 第四页 -->
      <div class="chart_box page-box">
        <p style="margin-top: 100px">2. 按访问量排名</p>
        <p v-if="zykWholeCase.zykLogRank.length >= 3">
          资源库项目中，“{{
          zykWholeCase.zykLogRank[0].zykName
          }}资源库”的访问量最多，紧随其后的是“{{ zykWholeCase.zykLogRank[1].zykName.indexOf('资源库')!=-1?zykWholeCase.zykLogRank[1].zykName:zykWholeCase.zykLogRank[1].zykName+'资源库' }}”和“{{
          zykWholeCase.zykLogRank[2].zykName
          }}资源库”。具体按照访问情况排名（前十名）如下表所示：
        </p>
        <div class="chart_name">
          表1 {{ province }}资源库访问量情况排名（前十名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库名称</th>
              <th>主持院校</th>
              <th>级别</th>
              <th>访问量（次）</th>
            </tr>
            <tr v-if="zykWholeCase.zykLogRank==undefined" class="nothing">
              <td colspan="5">无</td>
            </tr>
            <tr v-else v-for="(item, index) in zykWholeCase.zykLogRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.zykName }}</td>
              <td>{{ item.schoolName }}</td>
              <td>{{ item.projectTypeCn == '国家级'?'原国家级':item.projectTypeCn}}</td>
              <td>{{ parseInt(item.logNum) }}</td>
            </tr>
          </table>
        </div>
        <p style="margin-top: 100px">3. 按用户活跃数排名</p>
        <p v-if="zykWholeCase.zykActiveUserRank.length >= 3">
          资源库项目中，“{{
          zykWholeCase.zykActiveUserRank[0].name
          }}资源库”的活跃用户数最多，紧随其后的是“{{
          zykWholeCase.zykActiveUserRank[1].name
          }}资源库”和“{{
          zykWholeCase.zykActiveUserRank[2].name
          }}资源库”。具体按照用户活跃情况排名（前十名）如下表所示：
        </p>
        <div class="chart_name">
          表2 {{ province }}资源库用户活跃情况排名（前十名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库名称</th>
              <th>主持院校</th>
              <th>级别</th>
              <th>活跃用户数</th>
            </tr>
            <tr v-if="zykWholeCase.zykActiveUserRank==undefined" class="nothing">
              <td colspan="5">无</td>
            </tr>
            <tr v-else v-for="(item, index) in zykWholeCase.zykActiveUserRank" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.school }}</td>
              <td>{{ item.level == '国家级'?'原国家级':item.level}}</td>
              <td>{{ parseInt(item.activeNum) }}</td>
            </tr>
          </table>
        </div>
        <h5>1.5           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}资源库整体运行情况分析</h5>
        <h6>1.5.1 资源库用户运行情况</h6>
        <p>1. 用户新增情况</p>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，{{ province }}资源库共新增用户 {{getUtils_Fun(userInsert.allTotal)}} 人，其中学生用户新增{{
          getUtils_Fun(userInsert.Stotal)
          }}人，教师用户新增{{ getUtils_Fun(userInsert.Ttotal) }}人，企业用户新增{{getUtils_Fun(userInsert.Etotal)}} 人，社会学习者新增{{getUtils_Fun(userInsert.SocialTotal)}} 人。新增情况如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="userInsert.dataList"
            :transverseData="userInsert.transverse"
            :colorList="colorList"
            :legendList="['学生', '教师', '企业用户', '社会学习者']"
            :innerText="'单位：人'"
            :isoK="true"
          ></discountChart>
        </div>
        <div class="chart_name">
          图9 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}资源库用户新增趋势
        </div>
      </div>

      <!-- 第五页 -->
      <div class="chart_box page-box">
        <p class="m-top150">2. 用户活跃情况</p>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，{{ province }}资源库项目中累计活跃用户{{
          getUtils_Fun(userActive.userActiveTotal)
          }}人，累计访问量{{ getUtils_Fun(userActive.visitTotal) }}次。其中学生用户{{
          getUtils_Fun(userActive.student==undefined?0:userActive.student.num)
          }}人，累计访问共{{ getUtils_Fun(userActive.student==undefined?0:userActive.student.logNum) }}次；教师用户{{
          getUtils_Fun(userActive.teacher==undefined?0:userActive.teacher.num)
          }}人，累计访问共{{ getUtils_Fun(userActive.teacher==undefined?0:userActive.teacher.logNum) }}次；企业用户{{
          getUtils_Fun(userActive.company==undefined?0:userActive.company.num)
          }}人，累计访问共{{ getUtils_Fun(userActive.company==undefined?0:userActive.company.logNum) }}次；社会学习者{{
          getUtils_Fun(userActive.social==undefined?0:userActive.social.num)
          }}人，累计访问共{{ getUtils_Fun(userActive.social==undefined?0:userActive.social.logNum) }}次。各类型用户访问趋势图如下：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="userActive.userDataList"
            :transverseData="userActive.userTransverse"
            :colorList="colorList"
            :legendList="userActive.userLegend"
            :innerText="'单位：人'"
          ></discountChart>
        </div>
        <div class="chart_name">图10 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span> 资源库各类型用户访问趋势</div>
        <p class="m-top150">
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，{{ province }}资源库月活共
          <span v-if="type==1">{{getUtils_Fun(formatValue(userActive.userActiveTotal))}}</span>
          <span v-if="type==2">{{getUtils_Fun(formatValue(userActive.userActiveTotal/3))}}</span>
          <span v-if="type==3">{{getUtils_Fun(formatValue(userActive.userActiveTotal/12))}}</span>
          人，平均日活
          <span v-if="type==1">{{getUtils_Fun(formatValue(userActive.userActiveTotal/30))}}</span>
          <span v-if="type==2">{{getUtils_Fun(formatValue(userActive.userActiveTotal/90))}}</span>
          <span v-if="type==3">{{getUtils_Fun(formatValue(userActive.userActiveTotal/365))}}</span>
          人。
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="userActive.activeDataList"
            :transverseData="userActive.activeTransverse"
            :colorList="colorList"
            :innerText="'单位：人'"
          ></discountChart>
        </div>
        <div class="chart_name" style="margin-bottom: 120px">
          图11 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}资源库日活趋势
        </div>
        <p>3. 用户访问情况排名</p>
        <div class="chart_name">
          表3 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>
          {{ province }}资源库访问量排行榜（前十名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>序号</th>
              <th>资源库名称</th>
              <th>所属院校</th>
              <th>级别</th>
              <th>访问量（次）</th>
            </tr>
            <tr v-if="threeLeveluserVisit.rankTop10==undefined" class="nothing">
              <td colspan="5">无</td>
            </tr>
            <tr v-else v-for="(item, index) in threeLeveluserVisit.rankTop10" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.zykName }}</td>
              <td>{{ item.firstChargeUnit }}</td>
              <td>{{ item.projectTypeCn == '国家级'?'原国家级':item.projectTypeCn}}</td>
              <td>{{ parseInt(item.num) }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第六页 -->
      <div class="chart_box page-box">
        <h6 class="m-top150" style="margin-top: 150px">1.5.2 资源库课程运行情况</h6>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，{{ province }}资源库新增课程数为{{
          zykCourseRun.courseNewTotal
          }}门，资源库课程被访问量为{{
          getUtils_Fun(zykCourseRun.totalLog)
          }}次，其中{{zykCourseRun.transverse[0]}}被访问最多。具体情况如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="zykCourseRun.courseNew.value"
            :transverseData="zykCourseRun.courseNew.name"
            :colorList="colorList"
            :innerText="'单位：门'"
          ></discountChart>
        </div>
        <div class="chart_name">
          图12 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}资源库课程新增趋势
        </div>
        <div class="standards_content echartsHeight" style="height: 31.25rem;margin-top: 150px">
          <tcolumnarChart
            :refId="'typeDistributionChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="zykCourseRun.dataList"
            :transverseData="zykCourseRun.transverse"
            :colorList="colorList"
            :colorName="2"
            :innerText="'单位：次'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">
          图13 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}资源库课程被访问量排名（前十名）
        </div>
        <h6 class="m-top150" style="margin-top: 150px">1.5.3 资源库资源运行情况</h6>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，{{ province }}资源库新增资源数为{{
          getUtils_Fun(zykResourceRun.resourceNewTotal)
          }}条，资源被访问量达{{ getUtils_Fun(zykResourceRun.resourceVisitTotal) }}次，其中{{
          zykResourceRun.transverse[0]
          }}资源库资源被访问的次数最多，达{{ getUtils_Fun(zykResourceRun.dataList[0]) }}次。
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="zykResourceRun.resourceNew.value"
            :transverseData="zykResourceRun.resourceNew.name"
            :colorList="colorList"
            :innerText="'单位：条'"
          ></discountChart>
        </div>
        <div class="chart_name">
          图14 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}资源库资源新增趋势
        </div>
      </div>
      <!-- 第七页 -->
      <div class="chart_box page-box">
        <div class="standards_content echartsHeight m-top150" style="height: 31.25rem">
          <tcolumnarChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="zykResourceRun.dataList"
            :transverseData="zykResourceRun.transverse"
            :colorList="colorList"
            :colorName="2"
            :innerText="'单位：次'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">
          图15 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}资源库资源被访问量排名（前十名）
        </div>
        <h4 style="margin-top: 150px">2 {{over}}内原国家级专业教学资源库运行情况分析</h4>
        <p>
          {{ province }}原国家级职业教育专业教学资源库共计{{
          countryZyk.provinceTotalZyk
          }}个，其中担任第一主持单位的资源库数目{{
          countryZyk.provinceFirstChargeZyk
          }}个，担任联合主持单位的资源库数目{{ countryZyk.provinceUnionChargeZyk }}个，覆盖了{{
          countryZyk.provinceBigClass
          }}个专业大类和{{ countryZyk.professionCount }}个二级专业类。 目前，{{ province }}已有{{
          countryZyk.buildSchoolNum
          }}所职业院校和{{ countryZyk.companyCount }}家行业企业参与建设；资源库项目课程总量达到{{
          getUtils_Fun(countryZyk.courseTotal)
          }}门，其中标准化课程{{ getUtils_Fun(countryZyk.standard) }}门，资源库项目资源总量达{{
          getUtils_Fun(countryZyk.resourceTotal)
          }}余条，资源库共有注册用户{{ getUtils_Fun(countryZyk.zykUser) }}余人，总访问次数{{
          getUtils_Fun(countryZyk.zykVisitTotal)
          }}次。
        </p>
        <h5 style="margin-top: 150px">2.1 用户建设及应用情况</h5>
        <p>
          当前，{{ province }}原国家级职业教育专业教学资源库共有注册用户{{
          getUtils_Fun(countryUserBuild.zykUser)
          }}余人，按用户身份类型统计，教师{{ getUtils_Fun(countryUserBuild.teachNum) }}余人，学生{{
          getUtils_Fun(countryUserBuild.stuNum)
          }}余人，社会学习者用户{{
          getUtils_Fun(countryUserBuild.socialNum)
          }}余人，资源库总体用户访问资源总量{{
          getUtils_Fun(countryUserBuild.resourceVisitNum)
          }}次，用户访问课程总量{{
          getUtils_Fun(countryUserBuild.courseVisitNum)
          }}次，用户互动交流次数{{
          getUtils_Fun(countryUserBuild.communicateNum)
          }}次。具体用户分布详情如下所示：
        </p>
        <div class="standards_content echartsHeight" style="margin-top: 150px">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="countryUserBuild.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">图16 {{ province }}原国家级资源库用户整体情况</div>
      </div>

      <!-- 第八页-->
      <div class="chart_box page-box">
        <h5 class="m-top150" style="margin-top: 150px">2.2 课程建设及应用情况</h5>
        <p>
          当前，原国家级职业教育专业教学资源库课程建设总量达到{{
          getUtils_Fun(countryCourseBuild.courseTotal)
          }}门，其中标准化课程{{ getUtils_Fun(countryCourseBuild.standard) }}门，个性化课程{{
          getUtils_Fun(countryCourseBuild.personality)
          }}门，注册学生数最多的课程名《{{ countryCourseBuild.name }}》是属于“{{
          countryCourseBuild.zykName
          }}资源库”。课程按类型分布详情如下：
        </p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="countryCourseBuild.dataList"
            :transverseData="countryCourseBuild.transverse"
            :colorList="colorList"
            :colorName="2"
            :innerText="'单位：门'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图17 {{ province }}原国家级资源库课程整体情况</div>
        <h5>2.3 资源建设及应用情况</h5>
        <p>
          当前，{{ province }}原国家级职业教育专业教学资源库资源数量达{{
          getUtils_Fun(countryResourceBuild.resourceSum)
          }}余条，资源总容量达{{ countryResourceBuild.resourceCount }}TB，
          资源总量不断扩大，解决了传统教学中“讲不清、看不到、进不去、动不得、难再现”的问题；表现形式日趋丰富。资源访问总量已达{{
          getUtils_Fun(countryResourceBuild.resourceTotal)
          }}余次。 其中访问次数最多的资源是《{{
          countryResourceBuild.resourceVisitTopName
          }}》，属于“{{ countryResourceBuild.resourceVisitTopZyk }}”。
        </p>
        <p>资源按类型分布详情如下：</p>
        <div class="standards_content echartsHeight" style="height: 31.25rem">
          <tcolumnarChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="countryResourceBuild.resourceMap.value"
            :transverseData="countryResourceBuild.resourceMap.name"
            :colorList="colorList"
            :colorName="2"
            :innerText="'单位：条'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图18 {{ province }}原国家级资源库资源整体情况</div>
        <h5 style="margin-top: 80px">2.4 资源库总体应用情况</h5>
        <p v-if="zykWholeApply.professionZykRunList">
          截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，{{ province }}原国家级资源库覆盖{{
          zykWholeApply.provinceBigClass
          }}个专业大类。从专业大类分布看，所属{{
          zykWholeApply.professionZykRunList[0].profession_big_class
          }}的资源库最多，占比达{{
          zykWholeApply.proportion
          }}，担任第一主持单位的资源库运行数据详情如下表所示：
        </p>
        <div class="chart_name">表4 {{ province }}原国家级专业教学资源库运行详情</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>所属专业大类</th>
              <th>资源库名称</th>
              <th>第一主持院校</th>
              <th>总用户数</th>
              <th>教师数</th>
              <th>学生数</th>
              <th>总资源数</th>
              <th>标准化课程数</th>
              <th>总访问量</th>
            </tr>
            <tr v-if="zykWholeApply.professionZykRunList==undefined" class="nothing">
              <td colspan="11">无</td>
            </tr>
            <tr v-else v-for="(item, index) in zykWholeApply.professionZykRunList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.profession_big_class }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.userCount }}</td>
              <td>{{ item.teacherCount }}</td>
              <td>{{ item.studentCount }}</td>
              <td>{{ item.resourceCount }}</td>
              <td>{{ item.courseNum }}</td>
              <td>{{ item.logNum }}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第十页 -->
      <div class="chart_box page-box">
        <p>{{ province }}担任联合主持单位的资源库运行数据详情如下表所示：</p>
        <div class="chart_name">表5 {{ province }}原国家级联合主持单位的资源库运行数据详情</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>所属专业大类</th>
              <th>资源库名称</th>
              <th>总用户数</th>
              <th>教师数</th>
              <th>学生数</th>
              <th>总资源数</th>
              <th>标准化课程数</th>
              <th>总访问量</th>
            </tr>
            <tr v-if="zykWholeApply.jointChargeUnitList==undefined" class="nothing">
              <td colspan="11">无</td>
            </tr>
            <tr v-else v-for="(item, index) in zykWholeApply.jointChargeUnitList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.profession_big_class }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.userCount }}</td>
              <td>{{ item.teacherCount }}</td>
              <td>{{ item.studentCount }}</td>
              <td>{{ item.resourceCount }}</td>
              <td>{{ item.courseNum }}</td>
              <td>{{ item.logNum }}</td>
            </tr>
          </table>
        </div>

        <!--        todo-->
        <h5 style="margin-top: 50px">2.5 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}原国家级资源库运行情况分析</h5>
        <h6>2.5.1 用户运行情况</h6>
        <p>1. 用户新增情况</p>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，{{ province }}原国家级资源库共新增用户 {{ getUtils_Fun(userAddCase.allTotal)}} 人，其中学生用户新增{{
          getUtils_Fun(userAddCase.studentNum)
          }}人，教师用户新增{{ getUtils_Fun(userAddCase.teacherNum) }}人，企业用户新增{{ getUtils_Fun(userAddCase.enterpriseNum) }}人，社会学习者新增{{ getUtils_Fun(userAddCase.socialNum) }}人。新增情况如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="userAddCase.dataList"
            :transverseData="userAddCase.transverse"
            :colorList="colorList"
            :legendList="['学生', '教师', '企业用户', '社会学习者']"
            :innerText="'单位：人'"
            :isoK="true"
          ></discountChart>
        </div>
        <div class="chart_name">
          图22 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}原国家级资源库用户新增趋势
        </div>
        <p  style="margin-top: 180px">2. 用户活跃情况</p>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，{{ province }}原国家级资源库项目中累计活跃用户{{
          getUtils_Fun(userActiveCase.userActiveTotal)
          }}人，累计访问量{{ getUtils_Fun(userActiveCase.visitTotal) }}次。其中学生用户{{ getUtils_Fun(userActiveCase.student==undefined?0:userActiveCase.student.num) }}人，累计访问共{{
          getUtils_Fun(userActiveCase.student==undefined?0:userActiveCase.student.logNum)
          }}次；教师用户{{ getUtils_Fun(userActiveCase.teacher==undefined?0:userActiveCase.teacher.num) }}人，累计访问共{{
          getUtils_Fun(userActiveCase.teacher==undefined?0:userActiveCase.teacher.logNum)
          }}次；企业用户{{ getUtils_Fun(userActiveCase.company==undefined?0:userActiveCase.company.num) }}人，累计访问共{{
          getUtils_Fun(userActiveCase.company==undefined?0:userActiveCase.company.logNum)
          }}次； 社会学习者{{ getUtils_Fun(userActiveCase.social==undefined?0:userActiveCase.social.num) }}人，累计访问共{{
          getUtils_Fun(userActiveCase.social==undefined?0:userActiveCase.social.logNum)
          }}次。各类型用户访问趋势图如下：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="userActiveCase.userDataList"
            :transverseData="userActiveCase.userTransverse"
            :colorList="colorList"
            :legendList="userActiveCase.userLegend"
            :innerText="'单位：次'"
          ></discountChart>
        </div>
        <div class="chart_name">
          图23 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}原国家级资源库各类型用户访问趋势
        </div>
      </div>

      <!-- 第十二页 -->
      <div class="chart_box page-box" v-if="UserVisitRankCompleteNum">
        <p class="m-top150">
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，{{ province }}原国家级资源库月活共
          <span v-if="type==1">{{getUtils_Fun(formatValue(userActiveCase.userActiveTotalNum))}}</span>
          <span v-if="type==2">{{getUtils_Fun(formatValue(userActiveCase.userActiveTotalNum/3))}}</span>
          <span v-if="type==3">{{getUtils_Fun(formatValue(userActiveCase.userActiveTotalNum/12))}}</span>
          人，平均日活
          <span v-if="type==1">{{getUtils_Fun(formatValue(userActiveCase.userActiveTotalNum/30))}}</span>
          <span v-if="type==2">{{getUtils_Fun(formatValue(userActiveCase.userActiveTotalNum/90))}}</span>
          <span v-if="type==3">{{getUtils_Fun(formatValue(userActiveCase.userActiveTotalNum/365))}}</span>
          人。
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="userActiveCase.activeDataList"
            :transverseData="userActiveCase.activeTransverse"
            :colorList="colorList"
            :innerText="'单位：人'"
          ></discountChart>
        </div>
        <div class="chart_name" style="margin-bottom: 120px">
          图24 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}原国家级资源库日活趋势
        </div>
        <p>3. 用户访问情况排名</p>
        <div class="chart_name">
          表6 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>
          {{ province }}原国家级资源库访问量排行榜（前十名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>序号</th>
              <th>资源库名称</th>
              <th>所属院校</th>
              <th>访问量（次）</th>
            </tr>
            <tr v-if="userVisitRank.rankTop10.length == 0" class="nothing">
              <td colspan="4">无</td>
            </tr>
            <tr v-else v-for="(item, index) in userVisitRank.rankTop10" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.zykName }}</td>
              <td>{{ item.firstChargeUnit }}</td>
              <td>{{ parseInt(item.num) }}</td>
            </tr>
          </table>
        </div>
        <h6 class="m-top150">2.5.2 课程运行情况</h6>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，{{ province }}原国家级资源库新增课程数为{{
          courseRunCase.courseNewTotal
          }}门，其中标准化课程新增{{
          courseRunCase.standardCourseAddNum
          }}门，个性化课程新增{{
          courseRunCase.personalyCourseAddNum
          }}门，资源库课程被访问量为{{
          getUtils_Fun(courseRunCase.totalLog)
          }}次，其中“{{courseRunCase.transverse[0]}}”被访问的最多，具体情况如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="courseRunCase.courseNew.value"
            :transverseData="courseRunCase.courseNew.name"
            :colorList="colorList"
            :innerText="'单位：门'"
          ></discountChart>
        </div>
        <div class="chart_name">
          图25 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}原国家级资源库课程新增趋势
        </div>
      </div>

      <!-- 第十三页 -->
      <div class="chart_box page-box">
        <div class="standards_content echartsHeight m-top150" style="height: 31.25rem">
          <tcolumnarChart
            :refId="'typeDistributionChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="courseRunCase.dataList"
            :transverseData="courseRunCase.transverse"
            :colorList="colorList"
            :colorName="2"
            :innerText="'单位：次'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">
          图26 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}原国家级资源库课程被访问量排名（前十名）
        </div>

        <h6 style="margin-top: 150px">2.5.3 资源运行情况</h6>
        <p v-if="resourceRunCase.transverse.length > 0">
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，{{ province }}原国家级资源数新增为{{
          getUtils_Fun(resourceRunCase.resourceNewTotal)
          }}条，资源被访问量达{{ getUtils_Fun(resourceRunCase.resourceVisitTotal) }}次，其中“{{
          resourceRunCase.transverse[0]
          }}”被访问的次数最多，达{{ getUtils_Fun(resourceRunCase.dataList[0]) }}次。
        </p>
        <div class="standards_content echartsHeight" style="margin-top: 100px">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="resourceRunCase.resourceDistribution"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :showValue="true"
            :unit="'条'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">
          图27 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}原国家级资源库资源新增类型分布
        </div>
        <div class="standards_content echartsHeight" style="margin-top: 150px">
          <discountChart
            :refId="'usersMonthChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="resourceRunCase.resourceNew.value"
            :transverseData="resourceRunCase.resourceNew.name"
            :colorList="colorList"
            :innerText="'单位：条'"
          ></discountChart>
        </div>
        <div class="chart_name">
          图28 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}原国家级资源库资源新增趋势
        </div>
      </div>

      <div class="chart_box page-box">
        <div class="standards_content echartsHeight m-top150" style="height: 31.25rem;margin-top: 150px">
          <tcolumnarChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="resourceRunCase.dataList"
            :transverseData="resourceRunCase.transverse"
            :colorList="colorList"
            :colorName="2"
            :innerText="'单位：次'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">
          图29 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月'}}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Titledate.Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span  v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>{{ province }}原国家级资源库资源被访问量排名（前十名）
        </div>
        <div v-if="provinceUnNormalPushData.length != 0" style="margin-top: 150px">
          <h4>3 {{over}}内已纳入监测但数据尚未正常推送的资源库列表</h4>
          <div class="chart_name">表7 {{over}}内已纳入监测但数据尚未正常推送的资源库列表</div>
          <div class="biaoge">
            <table
              border="0"
              cellpadding="0"
              cellspacing="0"
              width="100%"
              bordercolor="#fff"
              class="course"
            >
              <tr>
                <th>序号</th>
                <th>资源库名称</th>
                <th>核心专业</th>
                <th style="width: 100px;">级别</th>
                <th>第一主持院校</th>
                <th>第二主持院校</th>
                <th>第三主持院校</th>
              </tr>

              <tr v-if="provinceUnNormalPushData==undefined" class="nothing">
                <td colspan="5">无</td>
              </tr>
              <tr
                v-else
                v-for="(item, index) in provinceUnNormalPushData"
                :key="index"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ item.zykName }}</td>
                <td>{{ item.profession }}</td>
                <td>{{ item.projectTypeCn }}</td>
                <td>{{ item.firstChargeUnit }}</td>
                <td>{{ item.secondChargeUnit }}</td>
                <td>{{ item.thirdChargeUnit }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; // 引入横柱图图表
import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
import distributionChart from "@/components/chart/distributionChart.vue"; // 地图
import pageToPDF from "@/utils/htmlToPdf.js";
import moment from "moment";

export default {
  components: {
    circularChart,
    tcolumnarChart,
    discountChart,
    distributionChart,
  },
  data() {
    return {
      threeLevelUserVisitCompelete: false,
      UserVisitRankCompleteNum: false,
      completeNum: 0, //统计接口数量
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], // 柱状图或折线图的颜色
      startDay: "",
      endDay: "",
      // 现在的时间
      nowMonth: "",
      nowDay: "",
      type: "",
      nowYear: "",
      Titledate: {
        Year: "",
        Month: "",
        Quarter: "",
      },
      over: "", //判断是省还是市
      // 2.1 国家级专业教学资源库运行分析
      countryZyk: {},
      // 2.1.1 用户建设及应用情况
      countryUserBuild: {},
      // 2.1.2 课程建设及应用情况
      countryCourseBuild: {},
      // 2.1.3 资源建设应用情况
      countryResourceBuild: {
        resourceMap: {
          name: [],
          value: [],
        },
      },
      // 2.1.4 资源库总体应用情况
      zykWholeApply: {},
      // 2.1.5 资源库建设及应用情况排名
      zykBuildRank: {
        resourceRank: {
          name: [],
        },
        logRank: {
          name: [],
        },
        userRank: {
          name: [],
        },
        zykRank: [],
      },
      // 2.1.6.1.1 用户新增情况
      userAddCase: {
        dataList: [],
        transverse: [],
      },
      // 2.1.6.1.2 用户活跃情况
      userActiveCase: {
        student: {},
        teacher: {},
        company: {},
        social: {},
        userDataList: [],
        userTransverse: [],
        userLegend: [],
        activeDataList: [],
        activeTransverse: [],
      },
      // 2.1.6.1.3. 原国家级用户访问情况排名
      userVisitRank: {
        rankTop10: [],
      },
      // 2.1.6.1.3. 用户访问情况排名
      threeLeveluserVisit: {
        rankTop10: [{"num":0}],
      },
      // 2.1.6.2 资源库课程运行情况
      courseRunCase: {
        courseNew: {
          value: [],
          name: [],
        },
        dataList: [],
        transverse: [],
      },
      // 2.1.6.3 资源库资源运行情况
      resourceRunCase: {
        resourceNew: {
          value: [],
          name: [],
        },
        dataList: [],
        transverse: [],
      },
      // 2.2 国家及省市校级专业教学资源库运行分析
      zykRunAnalysis: {},
      // 2.2.1 用户建设及应用情况
      userBuildApply: {
        dataList: [],
        studentTeacherDataList: [],
        studentTeacherTransverse: [],
        socialCompanyDataList: [],
        socialCompanyTransverse: [],
        cityOnlineStudyRank: [],
      },
      // 2.2.2 课程建设及应用情况
      courseBuildApply: {},
      courseVo: {},
      // 2.2.3 资源建设及应用情况
      resourceBuildApply: {
        resourceTypeMap: {
          name: [],
          value: [],
        },
        resourceVo: {
          name: [],
          value: [],
        },
      },
      // 2.2.4 资源库总体应用情况
      zykWholeCase: {
      professionBigClassList: [{"value":0}],
        zykLogRank: [],
        zykActiveUserRank: [],
        total: 0,
      },
      // 2.2.5.1.1 用户新增情况
      userInsert: {
        dataList: [],
        transverse: [],
      },
      // 2.2.5.1.2 用户活跃情况
      userActive: {
        student: {},
        teacher: {},
        company: {},
        social: {},
        userDataList: [],
        userTransverse: [],
        userLegend: [],
        activeDataList: [],
        activeTransverse: [],
      },
      // 2.2.5.1.3 用户访问情况排名
      userVisit: {
        rankLast10: [],
        rankTop10: [],
      },
      // 2.2.5.2 资源库课程运行情况
      zykCourseRun: {
        courseNew: {
          name: [],
          value: [],
        },
        dataList: [],
        transverse: [],
      },
      // 2.2.5.3 资源库资源运行情况
      zykResourceRun: {
        resourceNew: {
          name: [],
          value: [],
        },
        dataList: [],
        transverse: [],
      },
      provinceUnNormalPushData:[]
    };
  },
  created() {
    let token = this.$route.query.token;
    sessionStorage.setItem("lrmv2token", token);
    let zykid = this.$route.query.zykid;
    sessionStorage.setItem("zykId", zykid);

    this.startDay = this.$route.query.startDay;
    this.endDay = this.$route.query.endDay;
    this.type = this.$route.query.type;
    const currentMonth = parseInt(this.endDay.split("-")[1]);
    let quarter_num =  Math.floor(currentMonth / 4) + 1;
    if (quarter_num == 1 && this.type == 2) {
      this.Titledate.Quarter = "第1季度";
    } else if (quarter_num == 2 && this.type == 2) {
      this.Titledate.Quarter = "第2季度";
    } else if (quarter_num == 3 && this.type == 2) {
      this.Titledate.Quarter = "第3季度";
    } else if (quarter_num == 4 && this.type == 2) {
      this.Titledate.Quarter = "第4季度";
    }

    this.province = this.$route.query.province;
    this.province1 = this.$route.query.province1;
    if (
      this.province1 == "北京" ||
      this.province1 == "上海" ||
      this.province1 == "天津" ||
      this.province1 == "重庆"
    ) {
      this.over = "市";
    } else {
      this.over = "省";
    }

    this.nowDate(); // 获取当前时间日期
    this.getCountryZykRunAnalysis(); // 2.1 国家级专业教学资源库运行分析
    this.getCountryUserBuildApplyCase(); // 2.1.1 用户建设及应用情况
    this.getCountryCourseBuildApplyCase(); // 2.1.2 课程建设及应用情况
    this.getCountryResourceBuildApplyCase(); // 2.1.3 资源建设应用情况
    this.getZykWholeApplyCase(); // 2.1.4 资源库总体应用情况
    this.getCountryZykBuildRank(); // 2.1.5 资源库建设及应用情况排名
    this.getUserAddCase(); // 2.1.6.1.1 用户新增情况
    this.getUserActiveCase(); // 2.1.6.1.2 用户活跃情况
    this.getUserVisitRank(); // 2.1.6.1.3. 用户访问情况排名
    this.getZykCourseRunCase(); // 2.1.6.2 资源库课程运行情况资源库课程运行情况
    this.getZykResourceRunCase(); // 2.1.6.3 资源库资源运行情况
    this.getZykRunAnalysis(); // 2.2 国家及省市校级专业教学资源库运行分析
    this.getUserBuildApplyCase(); // 2.2.1 用户建设及应用情况
    this.getCourseBuildCase(); // 2.2.2 课程建设及应用情况
    this.getZykResourceBuildCase(); // 2.2.3 资源建设及应用情况
    this.getZykWholeCase(); // 2.2.4 资源库总体应用情况
    this.getThreeLevelUserAdd(); // 2.2.5.1.1 用户新增情况
    this.getThreeLevelUserActive(); // 2.2.5.1.2 用户活跃情况
    this.getThreeLevelUserVisitRank(); // 2.2.5.1.3 用户访问情况排名
    this.getThreeLevelZykCourseRunCase(); //  2.2.5.2 资源库课程运行情况
    this.getThreeLevelZykResourceRunCase(); // 2.2.5.3 资源库资源运行情况
    this.getProvinceUnNormalPushZykList();
  },
  mounted() {

  },
  methods: {
    // 截取当前日期的赋值操作
    nowDate() {
      let a = moment(new Date()).add("year", 0).format("YYYY-MM-DD");
      let Frist = this.startDay.indexOf("-") + 1;
      let last = this.endDay.lastIndexOf("-") + 1;
      this.nowYear = this.endDay.slice(0, Frist - 1);
      this.nowMonth = this.endDay.slice(Frist, last - 1).replace(/\b(0)/gi, "");
      this.nowDay = this.endDay.slice(last, a.length);
    },
    formatValue(num) {
      if(num == undefined || num == NaN || isNaN(num)){
        return 0;
      }
      return num.toFixed(0);
    },
    getUtils_Fun(num) {
      if(num == undefined || num == NaN || isNaN(num)){
        return 0;
      }
      const data =
        num > 100000000
          ? `${(num / 100000000).toFixed(2)}亿`
          : num > 10000
          ? `${(num / 10000).toFixed(2)}万`
          : num;
      return data;
    },
    // 2.1 国家级专业教学资源库运行分析
    getCountryZykRunAnalysis() {
      this.$axios
        .post(this.$apiurls.getCountryZykRunAnalysis, this.province1, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.countryZyk = res.data;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.1 用户建设及应用情况
    getCountryUserBuildApplyCase() {
      this.$axios
        .post(this.$apiurls.newGetCountryUserBuildApplyCase, this.province1, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.countryUserBuild = data;
            // 饼图数据
            let name = data.userMap.name;
            let value = data.userMap.value;
            let arr = [];
            for (let i = 0; i < name.length; i++) {
              arr.push({
                name: name[i],
                value: value[i],
              });
            }
            this.countryUserBuild.dataList = arr;
            this.countryUserBuild.stuNum = arr.find((item) => item.name === "学生").value;
            this.countryUserBuild.teachNum = arr.find((item) => item.name === "教师").value;
            this.countryUserBuild.socialNum = arr.find((item) => item.name === "社会学习者").value;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.2 课程建设及应用情况
    getCountryCourseBuildApplyCase() {
      this.$axios
        .post(this.$apiurls.newGetCountryCourseBuildApplyCase, this.province1, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.countryCourseBuild = data;
            this.countryCourseBuild.courseTotal = data.personality + data.standard;
            this.countryCourseBuild.dataList = [data.personality, data.standard];
            this.countryCourseBuild.transverse = ["个性化课程", "标准化课程"];
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.3 资源建设应用情况
    getCountryResourceBuildApplyCase() {
      this.$axios
        .post(this.$apiurls.newGetCountryResourceBuildApplyCase, this.province1, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.countryResourceBuild = data;
            this.countryResourceBuild.resourceSum = data.resourceMap.value.reduce(function (a, b) {
              return a + b;
            }, 0);
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.4 资源库总体应用情况
    getZykWholeApplyCase() {
      this.$axios
        .post(this.$apiurls.getZykWholeApplyCase, this.province1, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.zykWholeApply = res.data;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.5 资源库建设及应用情况排名
    getCountryZykBuildRank() {
      this.$axios
        .post(this.$apiurls.getCountryZykBuildRank, this.province1, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.zykBuildRank = res.data;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.6.1.1 用户新增情况
    getUserAddCase() {
      this.$axios
        .post(
          this.$apiurls.getUserAddCase,
          { endDay: this.endDay, province: this.province1, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.userAddCase.dataList = [data.student.value, data.teacher.value, data.enterprise.value, data.social.value];
            this.userAddCase.transverse = data.student.name;
            this.userAddCase.studentNum = data.student.value.reduce(function (a, b) {
              return a + b;
            }, 0);
            this.userAddCase.teacherNum = data.teacher.value.reduce(function (a, b) {
              return a + b;
            }, 0);
            this.userAddCase.enterpriseNum = data.enterprise.value.reduce(function (a, b) {
              return a + b;
            }, 0);
            this.userAddCase.socialNum = data.social.value.reduce(function (a, b) {
              return a + b;
            }, 0);
            this.userAddCase.allTotal = this.userAddCase.studentNum + this.userAddCase.teacherNum + this.userAddCase.enterpriseNum + this.userAddCase.socialNum;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.6.1.2 用户活跃情况
    getUserActiveCase() {
      this.$axios
        .post(
          this.$apiurls.getUserActiveCase,
          { endDay: this.endDay, province: this.province1, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.userActiveCase = data;
            this.userActiveCase.userActiveTotal = data.monthUserActiveStatus.userActiveTotal;
            this.userActiveCase.userDataList =
              data.monthUserActiveStatus.userActiveMonthRole.dataList;
            this.userActiveCase.userTransverse =
              data.monthUserActiveStatus.userActiveMonthRole.transverseData;
            this.userActiveCase.userLegend =
              data.monthUserActiveStatus.userActiveMonthRole.legendList;
            let active = data.monthUserActiveStatus.userActive;
            this.userActiveCase.student = active.find((item) => item.role === "学生");
            this.userActiveCase.teacher = active.find((item) => item.role === "教师");
            this.userActiveCase.company = active.find((item) => item.role === "企业用户");
            this.userActiveCase.social = active.find((item) => item.role === "社会学习者");
            let sum = 0;
            for (const item of active) {
              if (item.role !== "其他") {
                sum += item.logNum;
              }
            }
            this.userActiveCase.visitTotal = sum;
            let arr = data.monthUserActiveStatus.userActiveMonth;
            let dataList = [];
            let transverse = [];
            for (const item of arr) {
              dataList.push(item.value);
              transverse.push(item.name);
            }
            this.userActiveCase.activeDataList = dataList;
            this.userActiveCase.activeTransverse = transverse;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.6.1.3. 用户访问情况排名
    getUserVisitRank() {
      this.$axios
        .post(
          this.$apiurls.newGetUserVisitRank,
          { endDay: this.endDay, province: this.province1, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            this.userVisitRank = res.data;
          }
          this.completeNum = this.completeNum + 1;
          this.UserVisitRankCompleteNum = true;
        });
    },

    // 2.1.6.2 资源库课程运行情况
    getZykCourseRunCase() {
      this.$axios
        .post(
          this.$apiurls.getZykCourseRunCase,
          { endDay: this.endDay, province: this.province1, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.courseRunCase = data;
            let dataList = [];
            let transverse = [];
            for (const item of data.logRank) {
              dataList.push(item.num);
              transverse.push(item.zyk_name);
            }
            this.courseRunCase.dataList = dataList;
            this.courseRunCase.transverse = transverse;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.1.6.3 资源库资源运行情况
    getZykResourceRunCase() {
      this.$axios
        .post(
          this.$apiurls.getZykResourceRunCase,
          { endDay: this.endDay, province: this.province1, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.resourceRunCase = data;
            let dataList = [];
            let transverse = [];
            for (const item of data.resourceVisitRankTop10) {
              dataList.push(item.num);
              transverse.push(item.zyk_name);
            }
            this.resourceRunCase.dataList = dataList;
            this.resourceRunCase.transverse = transverse;

            let distributionData = res.data.resourceDistribution;
            this.resourceRunCase.resourceDistribution = [
              {
                name: "视频",
                value: distributionData.video,
              },
              {
                name: "图形图像",
                value: distributionData.image,
              },
              {
                name: "文本",
                value: distributionData.text,
              },
              {
                name: "PPT和富媒体",
                value: distributionData.ppt + distributionData.media + distributionData.courseware,
              },
              {
                name: "动画",
                value: distributionData.animation,
              },
              {
                name: "微课",
                value: distributionData.microCourses,
              },
              {
                name: "音频",
                value: distributionData.audio,
              },
              {
                name: "虚拟仿真",
                value: distributionData.simulation,
              },
              {
                name: "其他",
                value: distributionData.other,
              },
            ];
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2 国家及省市校级专业教学资源库运行分析
    getZykRunAnalysis() {
      this.$axios
        .post(this.$apiurls.getZykRunAnalysis, this.province1, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.zykRunAnalysis = res.data;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.1 用户建设及应用情况
    getUserBuildApplyCase() {
      this.$axios
        .post(
          this.$apiurls.newGetUserBuildApplyCase,
          { endDay: this.endDay, province: this.province1 },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.userBuildApply = data;
            // 饼图数据
            let name = data.zykUserRoleVo.name;
            let value = data.zykUserRoleVo.value;
            let arr = [];
            for (let i = 0; i < name.length; i++) {
              arr.push({
                name: name[i],
                value: value[i],
              });
            }
            this.userBuildApply.dataList = arr;
            this.userBuildApply.stuNum = arr.find((item) => item.name === "学生").value;
            this.userBuildApply.teachNum = arr.find((item) => item.name === "教师").value;
            this.userBuildApply.socialNum = arr.find((item) => item.name === "社会学习者").value;
            this.userBuildApply.companyNum = arr.find((item) => item.name === "企业员工").value;
            this.userBuildApply.studentTeacherDataList = [
              data.studentVisitCase.value,
              data.teacherVisitCase.value,
            ];
            this.userBuildApply.studentTeacherTransverse = data.studentVisitCase.name;
            this.userBuildApply.socialCompanyDataList = [
              data.socialVisitCase.value,
              data.enterpriseVisitCase.value,
            ];
            this.userBuildApply.socialCompanyTransverse = data.socialVisitCase.name;
            let sum = 0;
            for (const item of data.cityOnlineStudyRank) {
              sum += item.activeNum;
            }
            this.userBuildApply.activeStudent = sum;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.2 课程建设及应用情况
    getCourseBuildCase() {
      this.$axios
        .post(
          this.$apiurls.getCourseBuildCase,
          { endDay: this.endDay, province: this.province1 },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            this.courseBuildApply = res.data.zykCourseTotalBuild;
            this.courseVo = res.data.courseVo;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.3 资源建设及应用情况
    getZykResourceBuildCase() {
      this.$axios
        .post(
          this.$apiurls.getZykResourceBuildCase,
          { endDay: this.endDay, province: this.province1 },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            if (data.resourceVisitTopName)
              data.resourceVisitTopName = data.resourceVisitTopName.split(",")[0];
            this.resourceBuildApply = data;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.4 资源库总体应用情况
    getZykWholeCase() {
      this.$axios
        .post(this.$apiurls.getZykWholeCase, this.province1, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.zykWholeCase = data;
            let sum = 0;
            for (const item of data.professionBigClassList) {
              sum += item.value;
            }
            this.zykWholeCase.total = sum;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.5.1.1 用户新增情况
    getThreeLevelUserAdd() {
      this.$axios
        .post(
          this.$apiurls.getThreeLevelUserAdd,
          { endDay: this.endDay, province: this.province1, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            let data = res.data.provinceReportUserMonthNew;
            this.userInsert.dataList = [data.student.value, data.teacher.value, data.enterprise.value, data.social.value];
            this.userInsert.transverse = data.student.name;
            this.userInsert.Stotal = data.student.value.reduce(function (a, b) {
              return a + b;
            }, 0);
            this.userInsert.Ttotal = data.teacher.value.reduce(function (a, b) {
              return a + b;
            }, 0);
            this.userInsert.Etotal = data.enterprise.value.reduce(function (a, b) {
              return a + b;
            }, 0);
            this.userInsert.SocialTotal = data.social.value.reduce(function (a, b) {
              return a + b;
            }, 0);
            this.userInsert.allTotal = this.userInsert.Stotal + this.userInsert.Ttotal + this.userInsert.Etotal + this.userInsert.SocialTotal;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.5.1.2 用户活跃情况
    getThreeLevelUserActive() {
      this.$axios
        .post(
          this.$apiurls.getThreeLevelUserActive,
          { endDay: this.endDay, province: this.province1, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            let data = res.data.monthUserActiveStatus;
            this.userActive = data;
            this.userActive.userActiveAvgNum = res.data.userActiveAvgNum;
            this.userActive.userDataList = data.userActiveMonthRole.dataList;
            this.userActive.userTransverse = data.userActiveMonthRole.transverseData;
            this.userActive.userLegend = data.userActiveMonthRole.legendList;
            let active = data.userActive;
            this.userActive.student = active.find((item) => item.role === "学生");
            this.userActive.teacher = active.find((item) => item.role === "教师");
            this.userActive.company = active.find((item) => item.role === "企业用户");
            this.userActive.social = active.find((item) => item.role === "社会学习者");
            let sum = 0;
            for (const item of active) {
              if (item.role !== "其他") {
                sum += item.logNum;
              }
            }
            this.userActive.visitTotal = sum;
            let arr = data.userActiveMonth;
            let dataList = [];
            let transverse = [];
            for (const item of arr) {
              dataList.push(item.value);
              transverse.push(item.name);
            }
            this.userActive.activeDataList = dataList;
            this.userActive.activeTransverse = transverse;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.5.1.3 用户访问情况排名
    getThreeLevelUserVisitRank() {
      this.$axios
        .post(
          this.$apiurls.getThreeLevelUserVisitRank,
          { endDay: this.endDay, province: this.province1, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            this.threeLeveluserVisit = res.data;
          }
          this.threeLevelUserVisitCompelete = true;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.5.2 资源库课程运行情况
    getThreeLevelZykCourseRunCase() {
      this.$axios
        .post(
          this.$apiurls.getThreeLevelZykCourseRunCase,
          { endDay: this.endDay, province: this.province1, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.zykCourseRun = data;
            let dataList = [];
            let transverse = [];
            for (const item of data.logRank) {
              dataList.push(item.num);
              transverse.push(item.zyk_name);
            }
            this.zykCourseRun.dataList = dataList;
            this.zykCourseRun.transverse = transverse;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 2.2.5.3 资源库资源运行情况
    getThreeLevelZykResourceRunCase() {
      this.$axios
        .post(
          this.$apiurls.getThreeLevelZykResourceRunCase,
          { endDay: this.endDay, province: this.province1, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res.code === 200) {
            let data = res.data;
            this.zykResourceRun = data;
            let dataList = [];
            let transverse = [];
            for (const item of data.resourceVisitRankTop10) {
              dataList.push(item.num);
              transverse.push(item.zyk_name);
            }
            this.zykResourceRun.dataList = dataList;
            this.zykResourceRun.transverse = transverse;
          }
          this.completeNum = this.completeNum + 1;
        });
    },
    // 2.2.5.3 资源库资源运行情况
    getProvinceUnNormalPushZykList() {
      this.$axios
        .post(
          this.$apiurls.getProvinceUnNormalPushZykList, {province: this.province1 }, { loading: false}
        )
        .then((res) => {
          if (res.code === 200) {
            this.provinceUnNormalPushData = res.data;
          }
          this.completeNum = this.completeNum + 1;
        });
    },
    // 导出pdf文件
    exportPdf() {
      const lableList = document.getElementsByClassName("page-box");
      let year = this.endDay.split("-")[0];
      let month = this.endDay.split("-")[1];
      if(this.type==1){
        pageToPDF(`${year}_${this.province}_省级运行监测报告_${parseInt(month)}月`, this.$refs.pdfContent, lableList);
      }else if(this.type==2){
        pageToPDF(`${year}_${this.province}_省级运行监测报告_${this.Titledate.Quarter}`, this.$refs.pdfContent, lableList);
      }else if(this.type==3){
        pageToPDF(`${year}_${this.province}_省级运行监测报告_年度报告`, this.$refs.pdfContent, lableList);
      }
    },
  },
};
</script>
<style scoped>
  .analysisReport {
    width: 100%;
    /*height: 63020px;*/
  }

  * {
    margin: 0px;
    padding: 0px;
  }

  .analysisReport_box {
    /* width: 86.7%;
    margin: 0px auto;
    height: 73980px;*/
  }

  .header_titles {
    display: flex;
    justify-content: center;
    flex-flow: column;
    color: #000;
    text-align: center;
    position: relative;
  }

  .header_titles h1 {
    font-size: 55px;
    font-weight: bold;
    color: #1d244e;
  }

  .header_titles .monthly {
    font-size: 40px;
    font-weight: 400;
    color: #1d244e;
    line-height: 30px;
    margin-top: 6px;
  }

  .number_time {
    margin: 40px 0 60px 0;
  }

  .number_time div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #707f9d;
    font-size: 25px;
  }

  .number_time p {
    width: 100%;
    height: 1px;
    background: #707f9d;
    margin-top: 8px;
  }

  .number_time p:last-child {
    opacity: 0.5;
    margin-top: 4px;
  }

  .division {
    position: relative;
    clear: both;
    font-weight: bold;
    font-size: 44px;
    color: #1d244e;
    margin: 35px 0;
  }

  .chart_box,
  .catalogue h3 {
    font-weight: 700;
    font-size: 50px;
    color: #1d244e;
  }

  .chart_box h3 {
    font-size: 50px;
    margin-bottom: 35px;
  }

  .catalogue h3 {
    margin-bottom: 15px;
    margin-top: 50px;
    line-height: 40px;
  }

  .chart_box,
  .catalogue h4 {
    font-weight: 700;
    font-size: 50px;
    color: #1d244e;
  }

  .chart_box h4 {
    font-size: 42px;
    margin-top: 35px;
    margin-bottom: 35px;
  }

  .catalogue h4 {
    margin-bottom: 15px;
    margin-top: 50px;
  }

  .chart_box,
  .catalogue h5 {
    font-weight: 700;
    font-size: 45px;
    color: #1d244e;
  }

  .catalogue h5 {
    margin-bottom: 15px;
    margin-top: 50px;
    line-height: 40px;
  }

  .chart_box h5 {
    font-size: 40px;
    margin-top: 35px;
    margin-bottom: 35px;
  }

  .chart_box h6 {
    font-weight: 700;
    font-size: 39px;
    color: #1d244e;
    line-height: 40px;
    margin-bottom: 15px;
    margin-top: 50px;
  }

  .chart_box p {
    font-weight: 540;
    font-size: 35px;
    text-indent: 2em;
    line-height: 70px;
    color: #272a3f;
  }

  .chart_box .echartsHeight {
    /* width: 80%; */
    /* height: calc(100vw / 1080 * 300); */
    height: 400px;
    /* height:30rem; */
    margin: 10px auto 0px;
  }

  .chart_box .chart_name {
    font-weight: 540 !important;
    text-align: center;
    font-size: 32px;
    color: #272a3f;
    clear: both;
    /* margin-bottom: 40px; */
    margin-top: 20px;
  }

  .chart_box .notes {
    margin: 35px 0;
    line-height: 50px;
    font-size: 30px;
    color: black;
  }

  .export {
    width: 88px;
    height: 32px;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
  }

  .center {
    text-align: center;
  }

  .divorced {
    margin-top: 40px;
  }

  .biaoge {
    /* height: 720px; */
    font-weight: 540 !important;
    width: 97%;
    margin: 0px auto 25px;
    /* font-size: 16px !important; */
    color: #272a3f !important;
  }

  .biaoge .twoTable {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .course {
    text-align: center;
    margin: 0px 10px;
  }

  .course tr {
    height: 45px;
    line-height: 45px;
    color: #707f9d;
    font-size: 22px;
  }

  .course tr:nth-child(2n) {
    background: rgba(11, 201, 212, 0.2);
    color: #566178;
  }

  .course tr:nth-child(2n-1) {
    background: rgba(73, 187, 233);

    color: #566178;
  }

  .course tr:first-child {
    background: rgb(88, 136, 248);
    color: #fff;
  }

  ::v-deep .el-progress-bar__innerText {
    color: #000;
    font-size: 25px;
  }

  .HomePage {
    position: relative;
    padding-left: 10%;
    padding-top: 18%;
  }

  .HomePage #image {
    width: 559px;
    height: 70px;
    background: url("../../../../public/pdf_year.png") no-repeat;
    background-size: 100% 100%;
  }

  #PdfTitle {
    margin: 36% 0;
    padding: 20px 0px 20px 40px;
    position: relative;
    border-left: 3px solid #729ac0;
  }

  #FristTitle {
    font-size: 65px;
    font-weight: 700;
    margin-bottom: 40px;
  }

  #SecondTitle {
    font-size: 65px;
    font-weight: 600;
    margin-bottom: 40px;
  }

  #ThrendTitle {
    font-size: 50px;
    font-weight: 600;
    margin-bottom: 40px;
  }

  #FourTitle {
    font-size: 50px;
    font-weight: 700;
    margin-bottom: 40px;
  }

  #foot {
    display: flex;
  }

  .HomePage .footBox {
    flex-direction: column;
    display: flex;
    align-items: center;
    font-size: 42px;
    margin-left: 4.5%;
  }

  .HomePage #foot p {
    margin: 20px 0px;
  }

  /* 目录级别 */
  .catalogue .title {
    text-align: center;
    margin-bottom: 4%;
    font-size: 40px;
  }

  .top {
    margin-top: 140px;
  }
</style>
<style lang="scss" scoped>
  .page-box {
    // padding: 7% 0;
    // height: 2740px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    // border: 1px solid red;
    .m-top150 {
      margin-top: 150px;
    }

    .m-top50 {
      margin-top: 50px;
    }

    .m-top100 {
      margin-top: 100px;
    }

    .biaoge {
      width: 95%;
      margin: 25px auto;

      .course {
        text-align: center;
        margin: 0px 10px;

        tr {
          height: 42px;
          color: #707f9d;
          font-size: 22px;

          &:nth-child(2n) {
            background: #fff;
            color: #566178;
          }

          &:nth-child(2n-1) {
            background: #7ed2ff;
            color: #566178;
          }
        }
      }
    }
  }

  .catalogue {
    position: relative;
    // padding: 10% 8%;

    .title {
      text-align: center;
      margin-bottom: 4%;
      font-size: 40px;
    }

    .Second_text {
      padding-left: 1.8em;
    }

    .Thred_text {
      padding-left: 7.69em;
    }

    h5 {
      display: flex;
      align-items: center;

      .dot {
        flex: 1;
        border-top: dotted #1d244e 7px;
        /* 可设置大小，查属性参数dotted可换其他样式 */
        margin: 0 10px;
        /* 用来控制文字与填充线的间隔大小 */
      }
    }
  }

  .flex-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    & > div {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }

  .right {
    float: right;
    margin-right: 20px;
    font-size: 32px;
  }
</style>
